(function(){
    'use strict';

    angular
    .module('app')
    .controller('FiltrosController', FiltrosController)
    FiltrosController.$inject = ["FiltrosService","FieldsService", "$http","$timeout","$uibModal", "$log", "$document","$sce","ReportDefaultService"];
    function FiltrosController(FiltrosService,FieldsService,$http,$timeout,$uibModal, $log, $document,$sce,ReportDefaultService)
    {                         
        var vm = this; 
        vm.loading = false;

        vm.fields = [];
        vm.type = "";
        vm.filtros = {};
        vm.role_id = "";
        vm.user_id = "";
        vm.misfiltros = [];

        vm.getFiltros = function(){
        	vm.loading = true;
        	FiltrosService.getFiltros(vm,function(data){
            	vm.loading = false;
        		vm.misfiltros = data.misfiltros;
        	});
        }


        vm.modalBorrarFiltro = "";
        vm.borrarFiltro = function(filtro,index){
			vm.modalBorrarFiltro = $uibModal.open({
	              animation: true,
	              //windowClass : 'modal-success',
	              ariaLabelledBy: 'modal-title-top',
	              ariaDescribedBy: 'modal-body-top',
	              templateUrl: 'borrarfiltro.html',
	              size: 'lg',
	              controller: function($scope) {
	              	$scope.filtro = filtro;
	              	$scope.okForm = function(){
	              		FiltrosService.borrarFiltro(filtro,function(data){
	              			vm.misfiltros.splice(index,1);
	                    	vm.modalBorrarFiltro.close();
	                	});
	                }
	                $scope.koForm = function(){
	                    vm.modalBorrarFiltro.close();
	                }
	              }
	        });
        }

        vm.aplicarfiltro = function(filtro){
        	var href = window.location.href;
        	var hrefSplit = href.split("&");
        	if(hrefSplit.length>1){
	        	for(var cont=0;cont<hrefSplit.length;cont++){
	        		var igualSplit = hrefSplit[cont].split("=");
	        		if(igualSplit[0]=="mifiltro" || igualSplit[0]=="page"){
	        			hrefSplit.splice(cont,1);
	        			cont--;
	        		}
	        	}
	        }
	        window.location.href=hrefSplit.join("&")+"&mifiltro="+filtro.id;
        }

        vm.removeFilters = function(){
        	var href = window.location.href;
        	var hrefSplit = href.split("&");
        	if(hrefSplit.length>1){
	        	for(var cont=0;cont<hrefSplit.length;cont++){
	        		var igualSplit = hrefSplit[cont].split("=");
	        		if(igualSplit[0]=="mifiltro" || igualSplit[0]=="page"){
	        			hrefSplit.splice(cont,1);
	        			cont--;
	        		}
	        	}
	        }
	        window.location.href=hrefSplit.join("&");
        }


        vm.updateFiltro = function(filtro){
        	var res = false;
        	for(var cont=0;cont<vm.misfiltros.length && !res;cont++){
        		if(vm.misfiltros[cont].id==filtro.id){
        			
	        			vm.misfiltros[cont] = filtro;
        			
        			res = true;
        		}
        	}
        }

        vm.modalFiltroAdd = "";
        vm.addfiltro = function(filtro){
        	vm.loading = true;
        	if(filtro!=''){
				vm.type = filtro.node_type;
			}
        	FieldsService.getFieldsByNode(vm.type,true,function(data){
        		vm.fields = data.fields;
            	vm.loading = false;
            	vm.filtros.columnas = data.selecteds;
            	vm.modalFiltroAdd = $uibModal.open({
	              animation: true,
	              //windowClass : 'modal-success',
	              ariaLabelledBy: 'modal-title-top',
	              ariaDescribedBy: 'modal-body-top',
	              templateUrl: 'addfiltro.html',
	              size: 'lg',
	              controller: function($scope) {
	              	$scope.filtros = { "type" : vm.type };
	              	$scope.fields = vm.fields;
	              	$scope.selecteds = data.selecteds;
	              	$scope.id = "";

	              	$scope.filtros.fields = vm.fields;
	              	$scope.filtros.condiciones = [];
	              	$scope.filtros.condicionesOr = [];
					if(filtro!=''){
	              		$scope.filtros.force = filtro.force;
	              		$scope.filtros.condiciones = filtro.where_and;
	              		$scope.filtros.condicionesOr = filtro.where_or;
	              		//$scope.filtros.campos = filtro.fields;
	              		$scope.filtros.nombre = filtro.nombre;
	              		$scope.id = filtro.id;
	              		var valorSelecteds = JSON.parse(filtro.fields)
	              		$scope.selecteds = valorSelecteds.join(",");
	              	}

	              	$scope.addCondicion = function(){
	              		$scope.filtros.condiciones.push({"campo":"","operador":"","valor":""});
	              	}

	              	$scope.loadCampo = function(condicion){
	              		condicion.valor="";
	              		for(var cont=0;cont<$scope.fields.length;cont++){
	              			if($scope.fields[cont].name==condicion.campo){
	              				condicion.field = $scope.fields[cont];
	              				if(condicion.field.value != '')
		              				condicion.field.value = JSON.parse(condicion.field.value);
	              			}
	              		}
	              		$timeout(function(){
	              			$('.datepicker').datepicker({ format: 'yyyy-mm-dd'});
	              		})
	              	}

	              	$scope.borrarCond = function(index){
	              		$scope.filtros.condiciones.splice(index,1);
	              	}

	                $scope.okForm = function(){
	                	console.log($scope.filtros);
	                	FiltrosService.saveFiltro($scope.filtros,$scope.id,vm,function(data){
	                		if(filtro=="")
	                			vm.misfiltros.push(data.mifiltro);
	                		else
	                			vm.updateFiltro(data.mifiltro);
	                	});
	                    vm.modalFiltroAdd.close();
	                }
	                $scope.koForm = function(){
	                    vm.modalFiltroAdd.close();
	                }
	              }
	          	});
            });
        }


        vm.editarFiltro = function(filtro){
        	console.log(filtro);
        }

        vm.report = ReportDefaultService;
        vm.showmsg = false;
        vm.msgTitle = "" ;
        vm.msg = "" ;
        vm.progress = false;

        vm.report_id = '';

        vm.reportManager =  function (r)
        {
            vm.report.getReport(r,vm.report_id).then(function(data){
                vm.progress = data.progress;
        		vm.report_id = data.id;

                if(data.progress){
                    $timeout(function()
                        {
                            vm.reportManager(r);
                        },5000);
                }else{
                    vm.showmsg = true ;
                    vm.msgTitle = data.msgTitle ;
                    vm.msg =  data.msg ;
                }
            });
        };
		
    } 
  
})();